import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import './classes/AgentDirectory.css';
 import { configData } from "../config";
import SalespersonSidebar from "./SalespersonSidebar";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
 import { Link } from '@mui/material';
 import AgentBackendSidebar from "./AgentBackendSidebar";

// import { useMockServer } from '@mui/x-data-grid-generator';

const columns = [
  
  { field: 'name', headerName: 'Name', cellClassName:'name_column',headerClassName:'name_header', renderCell: (params) => (
        <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
          {params.row.name}
        </Link>
        )},
  { field: 'location', headerName: 'Location', cellClassName:'location_column',headerClassName:'location_header', sortable: false,filterable: false},
  { field: 'agent_scout_email', headerName: 'Agency - Scout Email', cellClassName:'agencyemail_column',headerClassName:'agencyemail_header',renderCell: (params) => (
        <a href={'mailto:'+params.row.agent_scout_email}  rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
          {params.row.agent_scout_email}
        </a>
        )},
];




const AgentDirectory =() =>{
  /* Pagination, filter config starts here */
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 30 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [isLoading, setIsLoading] = useState(true);
  const[message,setMessage] = useState([]);
  const loggedin_uid = localStorage.getItem('uid');
const app_url = configData.APP_URL;
const [formData, setformData] = useState({
       first_name:''
    });
const [appliedFormData, setAppliedFormData] = useState({
    first_name:''
  });
const handleChange = (event) => {
    const { name, value } = event.target;
    setformData({ ...formData, [name]: value });
    
  };
  const domainName = window.location.host.replace(/^https?:\/\//, '');
  useEffect(() => {
      Promise.all([
        checkpermissionforpageaccess()
      ])
      .then(() => {
  
      setIsLoading(false);
      })
  
  },[]);
              async function checkpermissionforpageaccess() {
       
          
               const response = await fetch(
                    app_url+'smwwagency/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                   {
                       method: "GET",
     
                       headers: {
                       'Content-Type': 'application/json',
                       },
                   }
               )           
               const responsedata = await response.json();
               if(responsedata.data.msg === "Success") {
                   
               } 
                if(responsedata.data.msg === "Error") {
                   setMessage(responsedata.data.result);
               } 
   
          
       }
  React.useEffect(() => {
   const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
      try {
         setIsLoading(true);
      const response = await fetch(app_url+'smwwagency/getdirectorylist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          //formData:formData
          formData:appliedFormData,
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };

    fetchData();
   
  }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change


  /* Pagination, filter config ends here */
const handleSubmit = async (e) => {
  e.preventDefault();
  setPaginationModel({
                 page: 0,
                    pageSize: 30,
                 });
                 setAppliedFormData({ ...formData });
  try {
         setIsLoading(true);
      const response = await fetch(app_url+'smwwagency/getdirectorylist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: 0,
          pageSize: 30,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount);  // Server should return totalRowCount
  }catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }

  
}; 
const handleClick = async (field,value) => {
   try {
         setIsLoading(true);
      const response = await fetch(app_url+'smwwagency/getdirectorylist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          [field]:value
        }),
      });
      const data = await response.json();
      
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
       }catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
 
    return(
      <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">

          <Helmet><title>Agents Directory</title></Helmet>
             <div class="left"></div>
               
               <div class="center left-center">
                {message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : (
                    <div className="sortflags-container">
                        <div className="agentdirectory-view-header">
                            <h1>Agent Directory</h1>
                            <p>Skip to: 
                               <a href onClick={()=>handleClick('last_name_starts_with','A')}>A</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','B')}>B</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','C')}>C</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','D')}>D</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','E')}>E</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','F')}>F</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','G')}>G</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','H')}>H</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','I')}>I</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','J')}>J</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','K')}>K</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','L')}>L</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','M')}>M</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','N')}>N</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','O')}>O</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','P')}>P</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','Q')}>Q</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','R')}>R</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','S')}>S</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','T')}>T</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','U')}>U</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','V')}>V</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','W')}>W</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','X')}>X</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','Y')}>Y</a>&nbsp;:&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','Z')}>Z</a>
                            </p>
                           
                        </div>
                        <div className="view-filters">
                            <form className="agentdirectory-filter-form">
                                <div className="agentdirectory-view-exposed-form">
                                    <div className="agentdirectory-view-exposed-widgets agentdirectory-clearfix">
                                        <div id="agentdirectory-edit-first-name" className="agentdirectory-views-exposed-widget agentdirectory-filter-first-name">
                                            <label htmlFor="agentdirectory-edit-first-name-value"> First Name </label>
                                                <div className="agentdirectory-views-widget">
                                                    <div className="agentdirectory-form-item  agentdirectory-form-textfield  agentdirectory-form-item-first-name-value">
                                                            <input type="text" id="first_name" name="first_name" size="30" 
                                                            onChange={handleChange} 
                                                            value={formData.first_name}
                                                            maxlength="128" className="agentdirectory-form-text"/>
                                                    </div>
                                                </div>
                                            </div>
                                                    
                                            <div className="agentdirectory-views-exposed-widget agentdirectory-views-submit-button">
                                                <input type="submit" id="agentdirectory-edit-submit" value="Apply" className="form-submit agentdirectory-form-submit" onClick={handleSubmit}/>    
                                            </div>


                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="agentdirectory-view-content">
                            <table className="agentdirectory-views-table">
                                   <div style={{  width: '100%' }}>
                                          <DataGrid
                                           rows={rows}
                                           columns={columns}
                                           rowCount={rowCount}
                                           paginationMode="server"
                                           sortingMode="server"
                                           filterMode="server"
                                           paginationModel={paginationModel}
                                           onPaginationModelChange={setPaginationModel}
                                           sortModel={sortModel}
                                           onSortModelChange={setSortModel}
                                            filterModel={filterModel}
                                           onFilterModelChange={setFilterModel}
                                           pageSizeOptions={[5, 10, 25,50]}
                                           getRowId={() => crypto.randomUUID()}
                                           getRowHeight={() => 'auto'}
                                           disableColumnFilter 
                                           disableColumnResize={true}
                                       />
    </div>
                            </table>
                        </div>

                    </div>
              )}
                </div>
                <div class="right">
                  <SalespersonSidebar />
                {/* {!isReady ? (
                  <></>
                ) : (domainName === configData.RSMWW_AGENCY_DOMAIN &&
                  userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) ? (
                  <>
                    <AgentBackendSidebar />
                    <SalespersonSidebar />
                  </>
                ) : (domainName === configData.RSMWW_AGENCY_DOMAIN &&
                  userLoggedInRoles.includes(configData.ROLE_AGENT)) ? (
                  <AgentBackendSidebar />
                ) : (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                  userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                  userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) ? (
                  <SalespersonSidebar />
                ) : (
                  <div>
                    <h1>Quick Links</h1>
                    <ul style={{padding: "0px"}}>
                        <li className='salesperson-header-hello-text'><a href={"/user/"+userLoggedInId.drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                        <li>
                        <a href="/smww_pay">
                        <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                        </a>
                        </li>
                    </ul>
                  </div>
                )} */}
                </div>
        
        </div>
      )}
    </>  
    );
};

export default AgentDirectory;